(() => {
  const groups = [
    {
      root: '.rakuzan-our-teas__grid',
      card: '.rakuzan-our-teas__card',
      title: '.rakuzan-our-teas__card-title',
      desc: '.rakuzan-our-teas__card-text',
    },
    {
      root: '.template-collection .product-grid',
      card: '.rakuzan-collection-card',
      title: '.rakuzan-collection-card__title',
      desc: '.rakuzan-collection-card__excerpt',
    },
    {
      root: '.rakuzan-related__grid',
      card: '.rakuzan-related__card',
      title: '.rakuzan-related__name',
      desc: '.rakuzan-related__desc',
    },
  ];

  const resetCard = (card) => {
    card.style.removeProperty('--rakuzan-card-title-height');
    card.style.removeProperty('--rakuzan-card-desc-height');
  };

  const alignRows = () => {
    groups.forEach(({ root, card: cardSelector, title: titleSelector, desc: descSelector }) => {
      document.querySelectorAll(root).forEach((grid) => {
        const cards = Array.from(grid.querySelectorAll(cardSelector));
        if (!cards.length) return;

        cards.forEach(resetCard);

        const rows = [];
        cards
          .map((card) => ({
            card,
            top: card.getBoundingClientRect().top,
          }))
          .sort((a, b) => a.top - b.top)
          .forEach((item) => {
            const row = rows.find((candidate) => Math.abs(candidate.top - item.top) < 80);

            if (row) {
              row.cards.push(item.card);
              row.top = Math.min(row.top, item.top);
            } else {
              rows.push({ top: item.top, cards: [item.card] });
            }
        });

        rows.forEach(({ cards: rowCards }) => {
          let titleHeight = 0;
          let descHeight = 0;

          rowCards.forEach((card) => {
            const title = card.querySelector(titleSelector);
            const desc = card.querySelector(descSelector);
            if (title) titleHeight = Math.max(titleHeight, title.getBoundingClientRect().height);
            if (desc) descHeight = Math.max(descHeight, desc.getBoundingClientRect().height);
          });

          rowCards.forEach((card) => {
            if (titleHeight) card.style.setProperty('--rakuzan-card-title-height', `${titleHeight}px`);
            if (descHeight) card.style.setProperty('--rakuzan-card-desc-height', `${descHeight}px`);
          });
        });
      });
    });
  };

  let frame = null;
  const scheduleAlignRows = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = null;
      alignRows();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleAlignRows);
  } else {
    scheduleAlignRows();
  }

  window.addEventListener('load', scheduleAlignRows);
  window.addEventListener('resize', scheduleAlignRows);
  document.addEventListener('shopify:section:load', scheduleAlignRows);

  if ('MutationObserver' in window) {
    new MutationObserver(scheduleAlignRows).observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }
})();
